import { ContentHoverPopover } from '@ui/content-hover-popover';
import { ICultureParamData } from '@@/agriculture/ts';
import styles from './index.module.sass';
import { spreadWheatType } from '@/modules/common/helpers/wheat-type.helper';

export function AgricultureHintParameters(props: IAgricultureHintParametersProps) {
  const {
    params,
    type,
    children,
    weight,
    culture,
    description,
    custom_name,
    filled = '',
  } = props;

  if ((!params || params.length === 0) && children) return children;
  // console.log(params);
  return (
    <ContentHoverPopover
      content={
        <table className={styles.root}>
          <tbody>
            <tr key={'Описание'}>
              <td>Описание объема</td>
              <td>{description ?? ' '}</td>
            </tr>
            <tr key={'Номер'}>
              <td>Номер на складе (ваш учёт)</td>
              <td>{custom_name ?? ' '}</td>
            </tr>
            <tr key={'Культура'}>
              <td>Культура</td>
              <td>{culture}</td>
            </tr>
            {params.map((p) => (
              <tr key={p.name}>
                <td>{p.name}</td>
                <td>
                  {p.name === 'Тип' && p.value
                    ? `${spreadWheatType(Number(p.value))?.sort} - ${
                        spreadWheatType(Number(p.value))?.type
                      }`
                    : p.value}
                  {' ' + p.units}
                </td>
              </tr>
            ))}
            <tr key={'Вес'}>
              <td>Вес</td>
              <td>{weight} т</td>
            </tr>
            {type === 'bunker' && (
              <tr key={'Дата'}>
                <td>Дата заполнения</td>
                <td>{filled}</td>
              </tr>
            )}
          </tbody>
        </table>
      }
    >
      {children}
    </ContentHoverPopover>
  );
}

export interface IAgricultureHintParametersProps {
  children?: JSX.Element;
  params: Array<ICultureParamData>;
  weight: number;
  culture: string;
  description: string;
  custom_name: string | number;
  filled: string;
  type: 'sleeve' | 'bunker';
}
